import React, { useEffect, useRef, useState } from "react";
import { API_ENDPOINTS, TERMS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import * as XLSX from "xlsx";
import {
  Form,
  Card,
  Row,
  Col,
  Button,
  InputGroup,
  Accordion,
} from "react-bootstrap";
import { pdf } from "@react-pdf/renderer";
import DatePicker from "react-datepicker";
import {
  IconExchange,
  IconHistoryToggle,
  IconFileTypeXls,
  IconBox,
  IconMessageCircle,
  IconCalendarWeek,
  IconLayoutGridFilled,
  IconLayoutListFilled,
  IconPaperclip,
  IconDotsVertical,
  IconPencil,
  IconEye,
  IconChevronRight,
  IconSearch,
} from "@tabler/icons-react";
import moment from "moment";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-blue/theme.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SKU_Version_POPUP from "./Modals/SKU_Version_POPUP";
import ExcelDialog from "./Modals/ExcelDialog";
import PdfDocument from "./PDF/main";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import View_ProjectDetails from "./ViewDetail/View_ProjectDetails";
import EmailHistory from "./Email/EmailHistory";
import EmailProjectDialog from "./Email/EmailProjectDialog";
import PriceChangesModal from "./PriceChange/PriceChangesModal";
import useIdleLogout from "../../hooks/useIdleLogout";
import ProjectListing from "./ProjectListing";

const ProjectTableListing = () => {
  const [page, setPage] = useState({
    active: 1,
    draft: 1,
    completed: 1,
    pending: 1,
  });
  const [limit, setLimit] = useState(10);
  const [rfqSku, setRfqSku] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [activeData, setActiveData] = useState([]);
  const [draftData, setDraftData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [activeStatuses, setActiveStatuses] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [search, setSearch] = useState("");
  const [salesHeadFilter, setSalesHeadFilter] = useState("");
  const [contractFilter, setContractFilter] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [hasMoreActive, setHasMoreActive] = useState(true);
  const [hasMoreDraft, setHasMoreDraft] = useState(true);
  const [hasMorePending, setHasMorePending] = useState(true);
  const [hasMoreCompleted, setHasMoreCompleted] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isListView, setIsListView] = useState(true);

  const statusOptions = [
    { label: "Draft", value: "DRAFT" },
    { label: "Pending", value: "PENDING" },
    { label: "Active", value: "ACTIVE" },
    { label: "Completed", value: "COMPLETED" },
  ];

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Success",
  });
  const [isModalOpen, setIsModalOpen] = useState({ show: false });
  const [isExcelOpen, setIsExcelOpen] = useState({ show: false });
  const [isPriceOpen, setIsPriceOpen] = useState({
    show: false,
    onSuccessFetch: false,
  });
  const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
    show: false,
    Quote_No: "",
    rfq_id: "",
  });
  const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
    show: false,
    rfq_id: "",
  });
  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    products: [],
    isStatusUpdate: false,
  });

  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const searchInputRef = useRef();
  const tableWrapperRefs = {
    row1: useRef(null),
    row2: useRef(null),
    row3: useRef(null),
    row4: useRef(null),
  };

  useIdleLogout();

  const {
    data: activeres,
    loadingActive,
    postData: fetchOpportunityActive,
  } = usePostRequest(API_ENDPOINTS.LISTING_PROJECT);
  const {
    data: completedres,
    loadingCompleted,
    postData: fetchOpportunityCompleted,
  } = usePostRequest(API_ENDPOINTS.LISTING_PROJECT);
  const {
    data: draftres,
    loadingDraft,
    postData: fetchOpportunityDraft,
  } = usePostRequest(API_ENDPOINTS.LISTING_PROJECT);
  const {
    data: penddingres,
    loadingPending,
    postData: fetchOpportunityPending,
  } = usePostRequest(API_ENDPOINTS.LISTING_PROJECT);
  const { data: contractData, postData: fetchContract } = usePostRequest(
    API_ENDPOINTS.GET_CONTRACT,
  );
  const { data: SalesHead, postData: fetchRfq } = usePostRequest(
    API_ENDPOINTS.GET_RFQ_USERS,
  );

  const statusCounts = {
    Pending: penddingres?.pagination?.totalRfqs || 0,
    Active: activeres?.pagination?.totalRfqs || 0,
    Completed: completedres?.pagination?.totalRfqs || 0,
    Draft: draftres?.pagination?.totalRfqs || 0,
  };

  useEffect(() => {
    setExcelData([
      ...activeData,
      ...draftData,
      ...pendingData,
      ...completedData,
    ]);
  }, [activeData, draftData, pendingData, completedData]);

  const handleGenerateExcel = (selectedFields) => {
    try {
      if (!excelData || excelData?.length === 0) {
        throw new Error("No data available to export");
      }
      if (!selectedFields || selectedFields.length === 0) {
        throw new Error("No fields selected for export");
      }

      const formattedData = excelData?.map((row) => {
        const filteredRow = {};
        selectedFields.forEach((field) => {
          switch (field) {
            case "Project Name":
              filteredRow[field] = row?.opportunity_name || "";
              break;
            case "Project No":
              filteredRow[field] = row.rfq_id || "";
              break;
            case "Contract Vehicle":
              filteredRow[field] = row.ContractType?.name || "";
              break;
            case "KO name":
              filteredRow[field] = row.rfqKo?.name || "";
              break;
            case "KO email":
              filteredRow[field] = row.rfqKo?.email || "";
              break;
            case "KO phone":
              filteredRow[field] = row.rfqKo?.phone || "";
              break;
            case "KO address":
              filteredRow[field] = row.rfqKo?.address || "";
              break;
            case "Published Date":
              filteredRow[field] = row.published_date
                ? moment(row.published_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Due Date":
              filteredRow[field] = row.due_date
                ? moment(row.due_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Project Description":
              filteredRow[field] = row.brief;
              break;
            case "Organization Name":
              filteredRow[field] = row.organization_name;
              break;
            case "Created Date":
              filteredRow[field] = row.created_at
                ? moment(row.created_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Last Updated Date":
              filteredRow[field] = row.updated_at
                ? moment(row.updated_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Status":
              filteredRow[field] = row.status;
              break;
            default:
              filteredRow[field] = "";
              break;
          }
        });
        return filteredRow;
      });

      if (formattedData.length === 0) {
        throw new Error("No valid data to export");
      }

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(formattedData);
      XLSX.utils.book_append_sheet(wb, ws, "ASPETTO SALES");
      const today = new Date();
      const excelFileName =
        "ASPETTO SALES-" + String(today).split("T")[0] + "(STATUS:).xlsx";
      XLSX.writeFile(wb, excelFileName);
    } catch (error) {
      console.error("Error generating Excel file:", error.message);
      alert(error.message);
    }
  };

  const handleSearch = () => {
    setActiveStatuses([]);
    const searchValue = searchInputRef.current.value?.trim();
    if ((startDate && !endDate) || (!startDate && endDate)) {
      toast.warning("Please select both the dates.");
      return;
    }
    setPage(() => ({
      draft: 1,
      active: 1,
      completed: 1,
      pending: 1,
    }));
    setSearch(searchValue);
    setIsInitialLoad(false);
    setIsSearchClicked(true);
  };

  const handlesalesHeadFilter = (e) => {
    setSalesHeadFilter(e.target.value);
    setPage((prev) => ({ ...prev, active: 1 }));
  };

  const handleViewClick = (row) => {
    setIsViewOpen({
      show: true,
      products: row,
      isStatusUpdate: false,
    });
    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${row.rfq_id}`;
    window.history.pushState(null, "", newUrl);
  };

  const handleClearFilter = () => {
    setSalesHeadFilter("");
    setContractFilter("");
    setSelectedStatus([]);
    setSearch("");
    setStartDate(null);
    setEndDate(null);
    setPage(() => ({
      draft: 1,
      active: 1,
      completed: 1,
      pending: 1,
    }));
    setIsInitialLoad(true);
    setIsSearchClicked(true);
  };

  const handleSKUVERSION_OPEN = (e, rfq) => {
    if (e) e.preventDefault();
    setRfqSku(rfq);
    setIsModalOpen({ show: true });
  };

  const toggleDropdown = (id) => {
    const isOpening = openDropdown !== id;
    setOpenDropdown(isOpening ? id : null);
    const sectionKey = id.split("-")[0];
    if (tableWrapperRefs[sectionKey] && tableWrapperRefs[sectionKey].current) {
      tableWrapperRefs[sectionKey].current.style.overflow = isOpening
        ? "visible"
        : "auto";
    }
    Object.entries(tableWrapperRefs).forEach(([key, ref]) => {
      if (key !== sectionKey && ref.current) {
        ref.current.style.overflow = "auto";
      }
    });
  };

  const handleDropdownAction = (rowId, action) => {
    const sectionKey = rowId.split("-")[0];
    setOpenDropdown(null);
    if (tableWrapperRefs[sectionKey] && tableWrapperRefs[sectionKey].current) {
      tableWrapperRefs[sectionKey].current.style.overflow = "auto";
    }
    action();
  };

  const onSuccessfulFetchActive = (response, reset = false) => {
    if (response?.data.length < limit) setHasMoreActive(false);
    setActiveData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      return Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
    });
  };

  const onSuccessfulFetchDraft = (response, reset = false) => {
    if (response?.data.length < limit) setHasMoreDraft(false);
    setDraftData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      return Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
    });
  };

  const onSuccessfulFetchPending = (response, reset = false) => {
    if (response?.data.length < limit) setHasMorePending(false);
    setPendingData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      return Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
    });
  };

  const onSuccessfulFetchCompleted = (response, reset = false) => {
    if (response?.data.length < limit) setHasMoreCompleted(false);
    setCompletedData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      return Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchRfq({ module_type: "RFQ" });
      await fetchContract();
    };
    fetchData();
  }, []);

  useEffect(() => {
    const isPagination = page.active > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("ACTIVE")));
    if (!shouldFetch) return;
    setHasMoreActive(true);
    fetchOpportunityActive(
      {
        page: page.active,
        project_type: "PROJECT",
        limit,
        status: "ACTIVE",
        sales_lead_email: salesHeadFilter || undefined,
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
      },
      (response) => onSuccessfulFetchActive(response, page.active === 1),
      setActiveStatuses((prev) =>
        prev.includes("ACTIVE") ? prev : [...prev, "ACTIVE"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.active, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.draft > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("DRAFT")));
    if (!shouldFetch) return;
    setHasMoreDraft(true);
    fetchOpportunityDraft(
      {
        page: page.draft,
        limit,
        project_type: "PROJECT",
        status: "DRAFT",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
      },
      (response) => onSuccessfulFetchDraft(response, page.draft === 1),
      setActiveStatuses((prev) =>
        prev.includes("DRAFT") ? prev : [...prev, "DRAFT"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.draft, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.pending > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("PENDING")));
    if (!shouldFetch) return;
    setHasMorePending(true);
    fetchOpportunityPending(
      {
        page: page.pending,
        limit,
        status: "PENDING",
        project_type: "PROJECT",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
      },
      (response) => onSuccessfulFetchPending(response, page.pending === 1),
      setActiveStatuses((prev) =>
        prev.includes("PENDING") ? prev : [...prev, "PENDING"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.pending, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.completed > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("COMPLETED")));
    if (!shouldFetch) return;
    setHasMoreCompleted(true);
    fetchOpportunityCompleted(
      {
        page: page.completed,
        limit,
        status: "COMPLETED",
        project_type: "PROJECT",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
      },
      (response) => onSuccessfulFetchCompleted(response, page.completed === 1),
      setActiveStatuses((prev) =>
        prev.includes("COMPLETED") ? prev : [...prev, "COMPLETED"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.completed, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  const handleLoadMoreActive = () => {
    if (hasMoreActive) setPage((prev) => ({ ...prev, active: prev.active + 1 }));
  };
  const handleLoadMoreDraft = () => {
    if (hasMoreDraft) setPage((prev) => ({ ...prev, draft: prev.draft + 1 }));
  };
  const handleLoadMorePending = () => {
    if (hasMorePending)
      setPage((prev) => ({ ...prev, pending: prev.pending + 1 }));
  };
  const handleLoadMoreCompleted = () => {
    if (hasMoreCompleted)
      setPage((prev) => ({ ...prev, completed: prev.completed + 1 }));
  };

  const renderRow = (row, sectionKey) => {
    const rowId = `${sectionKey}-${row.rfq_id}`;
    return (
      <tr key={rowId} className="align-middle">
        <td>{row?.ContractType?.name || "N/A"}</td>
        <td>{row?.rfq_id}</td>
        <td>{row?.sales_lead_name || "N/A"}</td>
        <td>{moment(row?.start_date).format("MM/DD/YYYY")}</td>
        <td>
          {row?.due_date === null
            ? "N/A"
            : moment(row?.due_date).format("MM/DD/YYYY")}
        </td>
        <td className="text-primary">
          {row?.project_budget !== null ? `$${row?.project_budget}` : "N/A"}
        </td>
        <td style={{ position: "relative" }}>
          <button
            onClick={() => toggleDropdown(rowId)}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            <IconDotsVertical size={20} />
          </button>
          {openDropdown === rowId && (
            <ul className="order-dropdown-menu p-0">
              <li
                className="dropdown-item"
                onClick={() =>
                  handleDropdownAction(rowId, () => {
                    navigate(`/edit-contract-vehicle/${row?.rfq_id}`);
                  })
                }
              >
                <span>
                  <IconPencil stroke={1} /> Edit
                </span>
                <IconChevronRight stroke={1} />
              </li>
              <li
                className="dropdown-item border-top"
                onClick={() =>
                  handleDropdownAction(rowId, () => handleViewClick(row))
                }
              >
                <span>
                  <IconEye stroke={1} /> View Details
                </span>
                <IconChevronRight stroke={1} />
              </li>
              <li
                className="dropdown-item border-top"
                onClick={() =>
                  handleDropdownAction(rowId, () =>
                    setIsPriceOpen({ show: true, data: row?.rfq_id }),
                  )
                }
              >
                <span>
                  <IconExchange stroke={1} /> Price Changes
                </span>
                <IconChevronRight stroke={1} />
              </li>
              <li
                className="dropdown-item border-top"
                onClick={() =>
                  handleDropdownAction(rowId, () =>
                    handleSKUVERSION_OPEN(null, row.rfq_id),
                  )
                }
              >
                <span>
                  <IconHistoryToggle stroke={1} /> Changes History
                </span>
                <IconChevronRight stroke={1} />
              </li>
              <li className="border-top">
                <div className="rfq_lis_short justify-content-center p-2">
                  <span>
                    <IconBox stroke={1} /> {row.RfqProducts?.length ?? 0}
                  </span>
                  <span>
                    <IconPaperclip stroke={1} /> {row.Attachments?.length ?? 0}
                  </span>
                  <span>
                    <IconMessageCircle stroke={1} />{" "}
                    {row.section.reduce(
                      (acc, section) => acc + section.notes.length,
                      0,
                    )}
                  </span>
                </div>
              </li>
            </ul>
          )}
        </td>
      </tr>
    );
  };

  const tableHead = (
    <thead>
      <tr>
        <th>Name</th>
        <th>Contract Number</th>
        <th>Sales Lead</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Total Budget</th>
        <th>Action</th>
      </tr>
    </thead>
  );

  return (
    <>
      {isModalOpen.show && (
        <SKU_Version_POPUP
          rfqSku={rfqSku}
          show={isModalOpen.show}
          setShow={setIsModalOpen}
        />
      )}
      {isEmailQuoteOpen.show && (
        <EmailProjectDialog
          username={user.username}
          show={isEmailQuoteOpen.show}
          rfq_id={isEmailQuoteOpen.rfq_id}
          Quote_No={isEmailQuoteOpen.Quote_No}
          setShow={setIsEmailQuoteOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}
      {isEmailHistoryOpen.show && (
        <EmailHistory
          show={isEmailHistoryOpen.show}
          rfq_id={isEmailHistoryOpen.rfq_id}
          setShow={setIsEmailHistoryOpen}
        />
      )}
      <View_ProjectDetails
        isStatusUpdate={isViewOpen.isStatusUpdate}
        onStatusUpdate={() =>
          setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
        }
      />
      {isPriceOpen.show && (
        <PriceChangesModal
          show={isPriceOpen?.show}
          setShow={setIsPriceOpen}
          rfqid={isPriceOpen?.data}
        />
      )}
      {isExcelOpen.show && (
        <ExcelDialog
          show={isExcelOpen.show}
          setShow={setIsExcelOpen}
          onDownload={(fields) => {
            handleGenerateExcel(fields);
            setIsExcelOpen({ show: false });
          }}
        />
      )}
      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen({ ...isSuccsessModalOpen, show: false })
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />

      {isListView ? (
        <div className="page-header d-print-none">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Contract Vehicles</h2>
            </div>
          </div>
        </div>
      ) : null}

      {isListView ? (
        <Card className="mb-3">
          <Card.Body>
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearch();
                }
              }}
            >
              <Row>
                <Col md={2} className="mb-2">
                  <Form.Label className="form-label">Search</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconSearch />
                    </InputGroup.Text>
                    <Form.Control
                      ref={searchInputRef}
                      type="text"
                      placeholder="Search..."
                      required
                      name="name"
                      autoComplete="off"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </InputGroup>
                </Col>
                <Col md={2} className="mb-2">
                  <Form.Label className="form-label">
                    Sales Lead Email
                  </Form.Label>
                  <Form.Select
                    className="form-control"
                    value={salesHeadFilter}
                    onChange={handlesalesHeadFilter}
                  >
                    <option value="">All</option>
                    {SalesHead?.data?.map((sales) => (
                      <option key={sales?.id} value={sales?.email}>
                        {sales?.email}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={2} className="mb-2">
                  <label className="form-label">Select Status</label>
                  <MultiSelect
                    value={selectedStatus}
                    options={statusOptions}
                    onChange={(e) => setSelectedStatus(e.value)}
                    optionLabel="label"
                    placeholder="All"
                    display="chip"
                    className="w-100"
                    panelHeaderTemplate={() => null}
                  />
                </Col>
                <Col md={4} className="mb-2">
                  <div className="d-flex gap-2">
                    <div className="w-100">
                      <Form.Label className="form-label">
                        Created Date From
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <IconCalendarWeek />
                        </InputGroup.Text>
                        <DatePicker
                          className="form-control"
                          selected={startDate}
                          placeholderText="Select Date"
                          onChange={(date) => setStartDate(date)}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          showMonthDropdown
                          showYearDropdown
                        />
                      </InputGroup>
                    </div>
                    <div className="w-100">
                      <Form.Label className="form-label">
                        Created Date To
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <IconCalendarWeek />
                        </InputGroup.Text>
                        <DatePicker
                          className="form-control"
                          selected={endDate}
                          placeholderText="Select Date"
                          onChange={(date) => setEndDate(date)}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate}
                          showMonthDropdown
                          showYearDropdown
                        />
                      </InputGroup>
                    </div>
                  </div>
                </Col>
                <Col md={3} className="mb-2 mt-2">
                  <div className="d-flex gap-1">
                    <Button
                      style={{ minWidth: "auto" }}
                      variant="warning"
                      onClick={handleSearch}
                    >
                      Apply Filters
                    </Button>
                    <Button
                      style={{ minWidth: "auto" }}
                      variant="outline-secondary"
                      onClick={handleClearFilter}
                    >
                      Clear Filters
                    </Button>
                    <Button
                      style={{ minWidth: "auto" }}
                      onClick={() => setIsExcelOpen({ show: true })}
                      variant="outline-success"
                    >
                      <IconFileTypeXls /> Download
                    </Button>
                  </div>
                </Col>
                <Form.Text>
                  Search by Project ID, contracting officer information,
                  description or any other relevant keyword.
                </Form.Text>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      ) : null}

      {isListView ? (
        <div className="d-flex align-items-center justify-content-end pt-2 pb-3 gap-3">
          <div className="view-toggle d-flex align-items-center justify-content-end gap-1">
            <IconLayoutGridFilled
              onClick={() => setIsListView(false)}
              style={{
                cursor: "pointer",
                color: !isListView ? "#FE6338" : "#515151",
              }}
            />
            <IconLayoutListFilled
              onClick={() => setIsListView(true)}
              style={{
                cursor: "pointer",
                color: isListView ? "#FE6338" : "#515151",
              }}
            />
          </div>
        </div>
      ) : null}

      {isListView ? (
        <div className="order_list_view">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0" className="border-0">
              <Accordion.Header>
                <span className="order_status_box draft_status">
                  Draft{" "}
                  <b style={{ color: "#818183ff" }}>{statusCounts.Draft}</b>
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="table-responsive mail_wrapper border-0 p-0"
                  ref={tableWrapperRefs.row1}
                  style={{ overflowX: "auto" }}
                >
                  <table className="table">
                    {tableHead}
                    <tbody>
                      {draftData.length > 0 ? (
                        draftData.map((row) => renderRow(row, "row1"))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {draftres?.data?.length >= 10 && hasMoreDraft && (
                    <div className="text-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={handleLoadMoreDraft}
                        disabled={loadingDraft}
                      >
                        {loadingDraft ? "Loading..." : "Load More"}
                      </Button>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className="border-0">
              <Accordion.Header>
                <span className="order_status_box pending_status">
                  Pending{" "}
                  <b style={{ color: "#F59F00" }}>{statusCounts.Pending}</b>
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="table-responsive mail_wrapper border-0 p-0"
                  ref={tableWrapperRefs.row2}
                  style={{ overflowX: "auto" }}
                >
                  <table className="table">
                    {tableHead}
                    <tbody>
                      {pendingData.length > 0 ? (
                        pendingData.map((row) => renderRow(row, "row2"))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {penddingres?.data?.length >= 10 && hasMorePending && (
                    <div className="text-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={handleLoadMorePending}
                        disabled={loadingPending}
                      >
                        {loadingPending ? "Loading..." : "Load More"}
                      </Button>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className="border-0">
              <Accordion.Header>
                <span className="order_status_box won_status">
                  Active <b style={{ color: "#198754" }}>{statusCounts.Active}</b>
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="table-responsive mail_wrapper border-0 p-0"
                  ref={tableWrapperRefs.row3}
                  style={{ overflowX: "auto" }}
                >
                  <table className="table">
                    {tableHead}
                    <tbody>
                      {activeData.length > 0 ? (
                        activeData.map((row) => renderRow(row, "row3"))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {activeres?.data?.length >= 10 && hasMoreActive && (
                    <div className="text-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={handleLoadMoreActive}
                        disabled={loadingActive}
                      >
                        {loadingActive ? "Loading..." : "Load More"}
                      </Button>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" className="border-0">
              <Accordion.Header>
                <span className="order_status_box won_status">
                  Completed{" "}
                  <b style={{ color: "#198754" }}>{statusCounts.Completed}</b>
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="table-responsive mail_wrapper border-0 p-0"
                  ref={tableWrapperRefs.row4}
                  style={{ overflowX: "auto" }}
                >
                  <table className="table">
                    {tableHead}
                    <tbody>
                      {completedData.length > 0 ? (
                        completedData.map((row) => renderRow(row, "row4"))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {completedres?.data?.length >= 10 && hasMoreCompleted && (
                    <div className="text-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={handleLoadMoreCompleted}
                        disabled={loadingCompleted}
                      >
                        {loadingCompleted ? "Loading..." : "Load More"}
                      </Button>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      ) : (
        <ProjectListing />
      )}
    </>
  );
};

export default ProjectTableListing;